export default "__VITE_ASSET__BhNpe8ZP__"